import React, { PureComponent } from 'react';
import { Row, Col, Well, Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LawPay from './LawPay';
import PayPal from './PayPal';
import { isEmptyObject } from '../../validators/formValidators';
import InvoiceItems from './InvoiceItems';
import { getCurrency } from '../../helpers/internationalization';


class PaymentProvider extends PureComponent {
    render() {
        const {
            accountType,
            amount,
            description,
            invoiceItems,
            forceInvoice = false
        } = this.props;

        if (forceInvoice && (!amount || amount == 0)) {
            return (
                <React.Fragment>
                <Row style={{ overflow: 'hidden' }}>
                {!isEmptyObject(invoiceItems) && invoiceItems.items && invoiceItems.items.length > 0 && (
                    <Col xs={12}>
                    <Panel header="Invoice Items">
                        <InvoiceItems invoiceItems={invoiceItems} />
                    </Panel>
                    </Col>
                )}
                {description && (
                    <Col xs={12}>
                    <Panel header="Description">
                        <Well>{description.split('\n').map(line => <span>{line}<br /></span>)}</Well>
                    </Panel>
                    </Col>
                )}
                </Row>
                </React.Fragment>
            )
        }

        if (accountType === 'None') {
            return (
                <div>
                <LawPay {...this.props} />
                <PayPal {...this.props} />
                </div>
            );
        }

        if (accountType === 'LawPay') {
            return <LawPay {...this.props} />
        }

        if (accountType === 'PayPal') {
            return <PayPal {...this.props} />
        }

        return <React.Fragment />;
    }
}

PaymentProvider.propTypes = {
    forceInvoice: PropTypes.bool,
    account: PropTypes.any,
    accountType: PropTypes.string,
    country: PropTypes.string.isRequired,
    invoiceItems: PropTypes.object,
    loading: PropTypes.bool,
    renderIntegrateButtonOnly: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
    const loggedIn = state.user.loggedIn;
    return {
        loggedIn,
        currency: getCurrency(loggedIn)
    };
};

export default connect(mapStateToProps)(PaymentProvider);
